import {type FC, useCallback} from 'react';

import type {GetComponentProps} from '@yourcoach/shared/utils/utility-types';

import {useI18n} from '@yourcoach/i18n';
import {ResendCodeButton} from '@yourcoach/shared/components/ResendCodeButton';
import {ApplyCodeStore} from '@yourcoach/shared/modules/auth/ApplyCode';
import {CodeInput} from '@yourcoach/shared/uikit/CodeInput';
import {LoadingSpinner} from '@yourcoach/shared/uikit/LoadingSpinner';

import type {Props} from './types';

import * as S from './styles';

export const EnterCodeForm: FC<Props> = ({
  code,
  inProgress,
  onCodeChange,
  onResendCodeButtonClick,
  resendTimeout,
  sentTo,
}) => {
  const {t} = useI18n();
  const onCodeChangeCb: GetComponentProps<typeof CodeInput>['onChange'] =
    useCallback(
      e => {
        onCodeChange(e.payload!.code);
      },
      [onCodeChange],
    );

  return (
    <S.Form>
      <S.Description>
        {t('web-app:AddAccount.sent_to_label', {
          sentTo: sentTo?.email || sentTo?.phone,
        })}
      </S.Description>
      <S.InputContainer>
        <CodeInput
          disabled={inProgress}
          length={ApplyCodeStore.CODE_SIZE}
          onChange={onCodeChangeCb}
          size={58}
          spacing={15}
          value={code}
        />
      </S.InputContainer>
      {inProgress ? (
        <S.LoadingSpinnerContainer>
          <LoadingSpinner />
        </S.LoadingSpinnerContainer>
      ) : null}
      {resendTimeout || inProgress ? (
        <S.ResendCodeButtonContainer>
          <ResendCodeButton
            disabled={inProgress}
            onClick={onResendCodeButtonClick}
            resendTimeout={resendTimeout || 0}
          />
        </S.ResendCodeButtonContainer>
      ) : null}
    </S.Form>
  );
};
